
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				<el-form-item  style="float:right;">
					<el-button type="warning" @click="handleAddMember">添加会员</el-button>
				</el-form-item>					
				<el-form-item  style="float:right;">
					<el-button type="primary" @click="handleAdd">添加运动员</el-button>
				</el-form-item>					
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getListData" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getListData" placeholder="姓名"></el-input>
				</el-form-item>
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="List" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>		
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="FullNname" label="姓名全拼" width="120" sortable>
			</el-table-column>			
			
			<el-table-column prop="EertificateType" label="证件类型" width="120"  :formatter="formatEertificateType" sortable>
			</el-table-column>            
			<el-table-column prop="LicenseNumber" label="证件号" width="240"  sortable>
			</el-table-column>
 			<el-table-column prop="Sex" label="性别" width="100"  :formatter="formatSex" sortable>
			</el-table-column>	           
			<el-table-column prop="Birthday" label="出生日期" width="180" :formatter="formatDate"  sortable>
			</el-table-column>
			<el-table-column prop="Phone" label="联系号码" width="150"  sortable>
			</el-table-column>	
			<el-table-column prop="CompetitionTeamStaffName" label="教练" width="150"  sortable>
			</el-table-column>	

			<el-table-column prop="Type" label="运动员类型" width="180" :formatter="formatType" sortable>
			</el-table-column>   
			<el-table-column  label="比赛证照" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="right" effect="light">
  				 <img v-if="scope.row.ImageUrl!=null"  @click="see(scope.row.ImageUrl)"  :src="scope.row.ImageUrl" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >

                    </el-tooltip>
				</template>				
			</el-table-column>	                               				

			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<!-- <el-table-column  label="变更状态" width="150" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="List[scope.$index].Id"   v-model="List[scope.$index].State==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="Change(scope.row,List[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>	             -->
            <el-table-column prop="State" label="状态" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==0">未上传证照</el-tag>
                  <el-tag type="success" size="medium" v-else-if="scope.row.State==1">正常</el-tag>
                  <el-tag type="danger" size="medium" v-else-if="scope.row.State==2">停用</el-tag>

                  </div>
                  </template>
			</el-table-column>			
			<el-table-column label="操作" min-width="250" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" type="primary" @click="imageShow(scope.$index, scope.row,'Photo')">上传照片</el-button>
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}个运动员</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="身高cm" prop="Height">
					<el-input-number v-model.number="editForm.Height" :min="0" :max="200" style="width:100%"></el-input-number>
				</el-form-item>	
 				<el-form-item label="体重kg" prop="Weight">
					<el-input-number v-model.number="editForm.Weight" :min="0" :max="200" style="width:100%"></el-input-number>
				</el-form-item>	     
 				<el-form-item label="教练" prop="CompetitionTeamStaffId">
                  <el-select v-model="editForm.CompetitionTeamStaffId"  clearable placeholder="请选择教练" style="width:100%">
                <el-option 
                     v-for="item in coachOptions"
                     :key="item.Id"
                     :label="item.Name"
                     :value="item.Id">
               </el-option>                                                                            
                 </el-select>				
                 </el-form-item>                          
				<el-form-item label="运动员类型" prop="Type">
                  <el-select v-model="editForm.Type"  clearable placeholder="请选择运动员类型" style="width:100%">
                <el-option 
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
               </el-option>                                                                             
                 </el-select>				
                 </el-form-item>
  				<el-form-item label="骨龄" prop="BoneAge">
					<el-input-number v-model.number="editForm.BoneAge" :min="0" :max="200" style="width:100%"></el-input-number>
				</el-form-item>	                  		  
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>	                                     
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
 				<el-form-item label="证件类型" prop="EertificateType">
                  <el-select v-model="addForm.EertificateType"  clearable placeholder="请选择证件类型" style="width:100%">
                <el-option 
                     v-for="item in opttionsType"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
               </el-option>                                                                             
                 </el-select>					
                 </el-form-item>
 				<el-form-item label="姓名" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>	                	                
                <el-form-item label="证件号" prop="LicenseNumber">
					<el-input v-model="addForm.LicenseNumber" auto-complete="off"></el-input>
				</el-form-item>	             
 				<el-form-item label="手机号" prop="Phone">
					<el-input v-model.number="addForm.Phone" auto-complete="off"></el-input>
				</el-form-item>    
 				<el-form-item label="姓名全拼" prop="FullNname">
					<el-input v-model="addForm.FullNname" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>                            
 				<el-form-item label="性别" prop="Sex">
					<el-radio-group v-model="addForm.Sex" v-if="addForm.EertificateType==0" :disabled="true">
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>
					<el-radio-group v-model="addForm.Sex" v-else>
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>                    
				</el-form-item>               
				<el-form-item label="出生日期" prop="Birthday">
					<el-date-picker v-if="addForm.EertificateType==0" :disabled="true" v-model="addForm.Birthday"  type="date" placeholder="选择日期" ></el-date-picker>
					<el-date-picker v-else   v-model="addForm.Birthday" auto-complete="off"  type="date" placeholder="选择日期" ></el-date-picker>
    			</el-form-item>	
				<el-form-item label="身高cm" prop="Height">
					<el-input-number v-model.number="addForm.Height" :min="0" :max="200" style="width:100%"></el-input-number>
				</el-form-item>	
 				<el-form-item label="体重kg" prop="Weight">
					<el-input-number v-model.number="addForm.Weight" :min="0" :max="200" style="width:100%"></el-input-number>
				</el-form-item>	 
				<el-form-item label="教练" prop="CompetitionTeamStaffId">
                  <el-select v-model="addForm.CompetitionTeamStaffId"  clearable placeholder="请选择教练" style="width:100%">
                <el-option 
                     v-for="item in coachOptions"
                     :key="item.Id"
                     :label="item.Name"
                     :value="item.Id">
               </el-option>                                                                            
                 </el-select>				
                 </el-form-item>                              
				<el-form-item label="运动员类型" prop="Type">
                  <el-select v-model="addForm.Type"  clearable placeholder="请选择运动员类型" style="width:100%">
                <el-option 
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
               </el-option>                                                                             
                 </el-select>				
                 </el-form-item>
  				<el-form-item label="骨龄" prop="BoneAge">
					<el-input-number v-model.number="addForm.BoneAge" :min="0" :max="200" style="width:100%"></el-input-number>
				</el-form-item>	                  	                                               					
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
        <el-dialog id="tt" title="照片上传" v-model="imageVisible" >
             <el-upload
              class="upload-demo"
              drag action=""
              :http-request="upload"
              multiple customClass=".el-upload-dragger">
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
		</el-dialog>
        <el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
		</el-dialog>			
        <el-dialog v-model="dialogTableVisible">
			<el-form  :inline="true" :model="filters" style="float: right;"  @submit.native.prevent>
				<el-form-item   >
					<el-input placeholder="物理卡号" v-model="dialogCardNumber"  ></el-input>
				</el-form-item>					
				<el-form-item   >
					<el-input placeholder="手机号码" v-model="dialogPhone"  ></el-input>
				</el-form-item>					
				<el-form-item   >
					<el-input placeholder="身份证号码" v-model="dialogIdCard"  ></el-input>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="dialogName"   placeholder="姓名"></el-input>
				</el-form-item>									
                <el-form-item  >
					<el-button   type="primary" v-on:click="selectDialogTable" icon="el-icon-search">查询</el-button>
				</el-form-item>

			</el-form>		
        <el-table  :data="dialogTableData" highlight-current-row v-loading="dialogTablelogLoading">	
			<el-table-column prop="Name" label="姓名" width="140" sortable>
			</el-table-column>				
			<el-table-column prop="Telephone" label="手机号码" width="140" sortable>
			</el-table-column>	
			<el-table-column prop="IdNumber" label="身份证号码" min-width="140" sortable>
			</el-table-column>			
			<el-table-column label="操作" width="140" fixed="right">
				<template  slot-scope="scope">
					<el-button type="primary" size="small"  @click="selectDialogTableRow(scope.row)">选择会员</el-button>				
				</template>
			</el-table-column>					
           </el-table>
		   	<el-col :span="24" class="toolbar">
			<el-tag>共有{{dialogTableCount}}条查询记录</el-tag>
			<!-- <el-pagination layout="prev, pager, next" @current-change="dialogTableCurrentChange" :page-size="10" :total="dialogTableCount" style="float:right;">
			</el-pagination> -->
	     	</el-col>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import {CheckLicenseNumber, getBasicList,UpdateTeamPlayer, getTeamStaffList, TeamPlayerList, removeTeamPlayer, addTeamPlayer,editTeamPlayer ,ChangeDimensionState } from '../../api/api';

	export default {
		data() {
			return {
				dialogCardNumber:'',
				dialogName:'',
				dialogPhone:'',
				dialogIdCard:'',
				dialogTableVisible:false,
				dialogTablelogLoading:false,
				dialogTableCount:0,
                dialogTableData:[],
                seeImageVisible:false,
                imgUrl:'',
                imageVisible:false,
                coachOptions:[],
                opttionsType:[
                    {
                        value:'0',
                        label:'中国大陆居民身份证'
                    },
                    {
                        value:'1',
                        label:'护照'
                    },
                    {
                        value:'2',
                        label:'其他证件'
                    }

                ],
                options:[
                    {
                     value: '0',
                    label: '业余选手'
                    },    
                     {
                     value: '1',
                    label: '三级运动员'
                    },  
                     {
                     value: '2',
                    label: '二级运动员'
                    },  
                     {
                     value: '3',
                    label: '一级运动员'
                    },  
                     {
                     value: '4',
                    label: '运动健将'
                    },  
                     {
                     value: '5',
                    label: '国际级运动健将'
                    },                            
                    
                ],
				filters: {
					Name: '',
					Type:'',				
				},
				fit:'contain',
				CompetitionTeamPlayerId:'',
				Count:0,
				List:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
                   Height: [
                        { required: true, message: '请输入身高'},
                        { type: 'number', message: '必须为数字值'}
                    ], 
                    Weight: [
                        { required: true, message: '请输入体重'},
                        { type: 'number', message: '必须为数字值'}
                    ],  
                      BoneAge: [
                        { required: true, message: '请输入骨龄'},
                        { type: 'number', message: '必须为数字值'}
                    ],                      
       				Type: [
                        {  required: true, message: '请选择工作身份', trigger: 'blur' }
                    ],                                         
                      CompetitionTeamStaffId: [
						{ required: true, message: '请选择教练', trigger: 'blur' }
                    ],                                        
				},
				//编辑界面数据
				editForm: {
					id: 0,
					Name: '',
					Phone:'',
					Remark:'',
                    EertificateType:'',
                    FullNname:'',
                    Birthday:'',
                    Sex:'',
                    Height:'',
                    Weight:'',
                    Type:'',
                    BoneAge:''
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {

                     CompetitionTeamStaffId: [
						{ required: true, message: '请选择教练', trigger: 'blur' }
                    ],    
 					LicenseNumber: [
						{ required: true, message: '请输入证件号', trigger: 'blur' }
                    ],                   
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
					Age: [
						{ required: true, message: '请输入出生日期', trigger: 'blur' }
                    ],                    	
       				EertificateType: [
                        {  required: true, message: '请选择证照类型', trigger: 'blur' }
                    ],                      		
 					Phone: [
                        { required: true, message: '请输入手机号码'},
                        { type: 'number', message: '必须为数字值'}
                    ],   
                    Height: [
                        { required: true, message: '请输入身高'},
                        { type: 'number', message: '必须为数字值'}
                    ], 
                    Weight: [
                        { required: true, message: '请输入体重'},
                        { type: 'number', message: '必须为数字值'}
                    ],  
                      BoneAge: [
                        { required: true, message: '请输入骨龄'},
                        { type: 'number', message: '必须为数字值'}
                    ],                   
     				IDnumber: [
                        {  required: true, message: '请输入证件号', trigger: 'blur' }
                    ],                     
      				Type: [
                        {  required: true, message: '请选择工作身份', trigger: 'blur' }
                    ],                     
                                                                       
                    
				},
				//新增界面数据
				addForm: {
					Name: '',
					Phone:'',
					Remark:'',
                    EertificateType:'',
                    FullNname:'',
                    Birthday:'',
                    Sex:'',
                    Height:'',
                    Weight:'',
                    Type:'',
					BoneAge:'',
					LicenseNumber:'',
					
				}
			}
		},
		methods: {
			selectDialogTableRow(row){

                	let para={LicenseNumber:row.IdNumber}
                  CheckLicenseNumber(para).then((res)=>{
					let { Success,Msg } = res.data;
					  if(Success)
					  {
			            	this.handleAdd();
				// this.addForm.EertificateType=0;
			         	this.addForm.Name=row.Name;
				        this.addForm.Phone=Number(row.Telephone);
				        this.addForm.Weight=row.Weight;
				        this.addForm.Height=row.Height;
				        this.addForm.LicenseNumber=row.IdNumber;
					  }else
					  {
                                   this.$message({
									message: Msg,
									type: 'error'
								});							  
					  }
				   	}).catch(error=>{
				   })


			},
			checkPlayer(value){
			   
				   
			},
			selectDialogTable(){
				if(this.dialogIdCard==''&&this.dialogPhone==''&&this.dialogName==''&&this.dialogCardNumber=='')
				{
                                   this.$message({
									message: '请输入查询数据',
									type: 'error'
								});		
								return;			
				}
				this.dialogTablelogLoading=true;
				let para={IdCard:this.dialogIdCard,Telephone:this.dialogPhone,Name:this.dialogName,IcCard:this.dialogCardNumber}
                  getBasicList(para).then((res)=>{
				   this.dialogTableData=res.data;
				   this.dialogTablelogLoading=false;
				   this.dialogTableCount=res.data.length;
				   this.dialogIdCard=='';
				   this.dialogPhone=='';
				   this.dialogName=='';
				   this.dialogCardNumber=='';
				   	}).catch(error=>{
				   })					
			},
			handleAddMember(){
				this.dialogTableVisible=true;
			},
			imageShow(index,row,type)
			{
				this.UploadType=type;
				this.CompetitionTeamPlayerId=row.Id;
			// console.log("111"+upload);
			  this.imageVisible=true;
			  
			},			
            see(imgUrl){
                     this.imgUrl=imgUrl;
                  this.seeImageVisible=true;
              },
            upload(param){
			    var fileObj=param.file;
			    console.log(param);

				var fd=new FormData();
				fd.append("file",fileObj);
				fd.append("CompetitionTeamPlayerId",this.CompetitionTeamPlayerId);
			  	UpdateTeamPlayer(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.getListData();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
		              
			  }).catch(error=>{
                 alert('网络错误');
                });                
            },
 			GetOptionList(){
				let para={IdentityEnum:1}
                  getTeamStaffList(para).then((res)=>{
				   this.coachOptions=res.data;
				    }).catch(error=>{
				   })					   				   
		    },           
		Change(row,index)
			{
				let para={
						id:index,				
				}
              ChangeDimensionState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.State=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
            },  
 			formatEertificateType: function (row, column) {
                  if(row.EertificateType==0)
                  {
                      return '身份证';
                  }else if(row.EertificateType==1)
                  {
                      return '护照';

                  }else if(row.EertificateType==2)
                  {
                      return '其它';

                  }else
                  {
                      return '未知';

                  }
			},                     
						//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
			formatType: function (row, column) {
				 if(row.Type==0)
				 {
					 return '业余选手';
				 }else if(row.Type==1)
				 {
					 return '三级运动员';
				 }else if(row.Type==2)
				 {
					 return '二级运动员';
				 }else if(row.Type==3)
				 {
					 return '一级运动员';
				 }else if(row.Type==4)
				 {
					 return '运动健将';
                 }else if(row.Type==5)
                 {
					 return '国际级运动健将';
                 }else
				 {
					 return '未知'
				 }
			},

			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			formatState: function (row, column) {
				return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			},
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.getListData();
			},

			getListData() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					Type:this.filters.Type,
				};
				this.listLoading = true;
				//NProgress.start();
				TeamPlayerList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
	
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeTeamPlayer(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getListData();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
                this.GetOptionList();
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
				this.editForm.Type= String(this.editForm.Type);
				this.editForm.CompetitionTeamStaffId= String(this.editForm.CompetitionTeamStaffId);
			},
			//显示新增界面
			handleAdd: function () {
                this.GetOptionList();
				this.addFormVisible = true;
				this.addForm= {
					Name: '',
					Phone:'',
					IDnumber:'',
					Remark:'',
					IdentityEnum:'',
				}
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {

							this.editLoading = true;
							let para = Object.assign({}, this.editForm);
							editTeamPlayer(para).then((res) => {
								this.editLoading = false;
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getListData();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							 if(!(/^1[3456789]\d{9}$/.test(this.addForm.Phone)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }
							 if(this.addForm.EertificateType==0) 
							 {
							 if(!(/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.addForm.LicenseNumber)))
							 {
                                this.$message({
									message: '身份证号码不正确',
									type: 'error'
								});
                               return ;
							 }
							 }

							this.addLoading = true;
							let para= Object.assign({}, this.addForm);							
							addTeamPlayer(para).then((res) => {							
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								    });
								this.addLoading = false;
								this.addFormVisible = false;
								this.getListData();
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								   });
							    	this.addLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getListData();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
.customWidth{
        width:22%;
    }
.el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
}
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// TeamPlayer.vue?c561fe90